/* global window */
import $ from 'jquery';
import querySelectors from '../utils/querySelectors';

const mobileMenu = function (selectors, { activeClass }) {
    const history = window.history;
    const instanceId = (new Date().getUTCMilliseconds() + Math.random()).toString();
    let $$ = [];
    let menuActiveClass = '';

    const isOpen = () => {
        return history.state && history.state.open && history.state.instanceId === instanceId;
    };

    const construct = () => {
        const settings = Object.assign({
            button: '',
            menu: ''
        }, selectors);
        menuActiveClass = activeClass;
        $$ = querySelectors(settings);
    };

    const run = () => {
        $$.button.on('click', events.buttonOnClick);
        $(window).on('popstate', events.windowOnPopState);
    };

    const methods = {
        open() {
            history.pushState({
                instanceId,
                open: true
            }, 'main-menu-open');
        },
        close() {
            history.pushState({
                instanceId,
                open: false
            }, 'main-menu-close');
        },
        toggleClass() {
            isOpen() ? $$.menu.addClass(menuActiveClass) : $$.menu.removeClass(menuActiveClass);
        }
    };

    const events = {
        buttonOnClick(e) {
            e.preventDefault();
            isOpen() ? methods.close() : methods.open();
            methods.toggleClass();
        },
        windowOnPopState() {
            methods.toggleClass();
        }
    };

    construct();

    return {
        run
    }

};

export default mobileMenu;


// WEBPACK FOOTER //
// ./src/js/modules/mobileMenu.js